export default __webpack_public_path__ + "static/media/world-b-title.280624d7.png";